// -------------------------------------------
// ❄️ Snowfall - Natural + Randomized (Diwali-style execution)
// -------------------------------------------
(() => {
  'use strict';
  if (window.__snow_effect_loaded) return;
  window.__snow_effect_loaded = true;

  const canvas = document.createElement('canvas');
  canvas.id = 'snow-canvas';
  Object.assign(canvas.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: '9999',
  });
  document.body.appendChild(canvas);

  const ctx = canvas.getContext('2d', { alpha: true });
  let w = 0, h = 0, dpr = 1;

  function resize() {
    w = document.documentElement.clientWidth;
    h = document.documentElement.clientHeight;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize, { passive: true });

  // ❄️ Snowflake class
  class Snowflake {
    constructor(resetY = true) {
      this.reset(resetY);
    }
    reset(resetY) {
      this.x = Math.random() * w;
      this.y = resetY ? Math.random() * -h : Math.random() * h;
      this.size = Math.random() * 1.5 + 2.5;
      this.speedY = Math.random() * 1.2 + 0.8;
      this.speedX = Math.random() * 0.8 - 0.3;
      this.swing = Math.random() * 0.02 + 0.005;
      this.opacity = Math.random() * 0.6 + 0.3 + 0.4;
    }
    update() {
      this.y += this.speedY;
      this.x += Math.sin(this.y * this.swing) + this.speedX;

      if (this.y > h + 10) this.reset(true);
      if (this.x < -10) this.x = w + 10;
      if (this.x > w + 10) this.x = -10;
    }
    draw() {
      ctx.globalAlpha = this.opacity;
      ctx.fillStyle = '#ffffff';
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalAlpha = 1;
    }
  }

  const snowflakes = [];
  const snowCount = w < 768 ? 70 : 140;
  for (let i = 0; i < snowCount; i++) {
    snowflakes.push(new Snowflake(false));
  }

  function animate() {
    ctx.clearRect(0, 0, w, h);

    for (let i = 0; i < snowflakes.length; i++) {
      snowflakes[i].update();
      snowflakes[i].draw();
    }
  }

  // ⏱️ Auto-stop after 30s (same as Diwali)
  window.addEventListener('load', () => {
    const start = performance.now();
    function loop(ts) {
      if (ts - start < 60000) {
        animate();
        requestAnimationFrame(loop);
      } else {
        canvas.remove();
      }
    }
    requestAnimationFrame(loop);
  });
})();
